import { useNavigate } from "react-router-dom";

function Landing() {
	const navigate = useNavigate();

	const handleAnalyze = () => {
		navigate("/dashboard");
	};

	const handleRegister = () => {
		navigate("/register");
	};

	return (
		<section className="page page--landing">
			<div className="hero">
				<p className="eyebrow">Auditorías impulsadas por Lighthouse</p>
				<h1>Impulsa el rendimiento y la accesibilidad de tu sitio</h1>
				<p className="hero__subtitle">
					Advance Web sintetiza los datos de PageSpeed Insights en un panel claro,
					con recomendaciones priorizadas listas para tu siguiente sprint.
				</p>
				<div className="hero__actions">
					<button className="button button--primary" onClick={handleAnalyze}>
						Comenzar auditoría
					</button>
					<button className="button button--ghost" onClick={handleRegister}>
						Crear cuenta gratis
					</button>
				</div>
				<ul className="hero__highlights">
					<li>Reportes Core Web Vitals en tiempo real</li>
					<li>Historial de ejecuciones por proyecto</li>
					<li>Exportación lista para stakeholders</li>
				</ul>
			</div>
			<div className="hero__card">
				<p className="hero__card-eyebrow">Tiempo promedio por auditoría</p>
				<h2>38 segundos</h2>
				<p className="hero__card-note">
					Optimizado con caché inteligente y peticiones paralelas hacia la API de Google
					PageSpeed para entregarte resultados casi en tiempo real.
				</p>
			</div>
		</section>
	);
}

export default Landing;
